module.exports = __webpack_public_path__ + "img/tb1039-2-74.prt.d019b85a.jpg";